import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import Select from "@mittwald/flow-components/dist/components/Select";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import useSelector from "@mittwald/flow-lib/dist/hooks/useSelector";
import React, { Suspense, useEffect, useState } from "react";
import sessionStore from "../../../../../../store/session";
import type {
  RelocationFormData,
  RelocationReferrer,
} from "../../../RelocationRequestWidget";
import { relocationWidgetStore } from "../../../store/RelocationWidgetStore";
import type { Contract } from "../../../types/LegacySystemAPI";
import { LegacySystemAPI } from "../../../utils/LegacySystemAPI";
import { isNewSystem } from "../../../utils/RelocationUtils";
import { ProjectInformationBanner } from "../../ProjectInformationBanner/ProjectInformationBanner";
import { StepHeaderItem } from "../../StepHeaderItem";
import { TariffType } from "../TariffStep/utils/TariffUtils";
import { ProjectNumberInput } from "./components/ProjectNumberInput/ProjectNumberInput";
import { ProjectSelect } from "./components/ProjectSelect/ProjectSelect";

interface TargetStepContentProps {
  referrer: RelocationReferrer;
}

export const TargetStepContent: React.FC<TargetStepContentProps> = (props) => {
  const { referrer } = props;
  const form = useFormContext<RelocationFormData>();

  const isLoggedIn = useSelector(
    () => !!sessionStore._accessToken || !!relocationWidgetStore.accessToken,
  );
  const customerNumber = useSelector(
    () => relocationWidgetStore.customerNumber,
  );

  const tariffType = form.watch("target.product") as TariffType;
  const targetProduct = form.watch("target.projectName");
  const isProjectSelect = targetProduct !== "";

  const [contracts, setContracts] = useState<Contract[]>([]);

  useEffect(() => {
    if (!isNewSystem(form)) {
      void LegacySystemAPI.getContracts(customerNumber).then((data) => {
        setContracts(data);
      });
    }
  }, []);

  const informationInputs = (
    <Section.Item>
      {(tariffType === TariffType.PRO_SPACE ||
        tariffType === TariffType.SPACE_SERVER) && (
        <Suspense
          fallback={
            <Select.View
              disabled
              label="projectSelect"
              options={[]}
              placeholder="projectSelect.placeholder"
            />
          }
        >
          <ProjectSelect isLoggedIn={isLoggedIn} referrer={referrer} />
        </Suspense>
      )}
      {(tariffType === TariffType.AGENCY_SERVER ||
        tariffType === TariffType.CMS_HOSTING ||
        tariffType === TariffType.SHOP_HOSTING) && (
        <ProjectNumberInput contracts={contracts} isLoggedIn={isLoggedIn} />
      )}
    </Section.Item>
  );

  const informationBanner = isProjectSelect ? (
    <ProjectInformationBanner />
  ) : null;

  return (
    <TranslationProvider name="targetStepContent" type="component">
      <Section.Layout>
        <StepHeaderItem description="description" headline="headline">
          {informationInputs}
          {informationBanner}
        </StepHeaderItem>
      </Section.Layout>
    </TranslationProvider>
  );
};
